export default __webpack_public_path__ + "static/img-7-4d76c7158a57273910cd397296a0e9e9.png";